import React from 'react';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
	// some basic styles to make the items look a bit nicer
	userSelect: 'none',
	padding: grid * 2,
	// margin: `0 0 ${grid}px 0`,

	// change background colour if dragging
	// background: isDragging ? 'lightgreen' : 'grey',

	// styles we need to apply on draggables
	...draggableStyle,
});

const getListStyle = isDraggingOver => ({
	// background: isDraggingOver ? 'lightblue' : 'lightgrey',
	padding: grid,
	// width: 250,
});

const ImageGridList = ({ images, onDelete, onReorder = () => {} }) => {
	const onDragEnd = result => {
		if (!result.destination) {
			return;
		}
		onReorder(result.source.index, result.destination.index);
	};
	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<Droppable droppableId='droppable'>
				{(provided, snapshot) => (
					<div
						{...provided.droppableProps}
						ref={provided.innerRef}
						style={getListStyle(snapshot.isDraggingOver)}
					>
						{images.map((image, index) => (
							<Draggable
								key={`${index}`}
								draggableId={`${index}`}
								index={index}
							>
								{(provided, snapshot) => (
									<div
										ref={provided.innerRef}
										{...provided.draggableProps}
										{...provided.dragHandleProps}
										style={getItemStyle(
											snapshot.isDragging,
											provided.draggableProps.style
										)}
									>
										{image && (
											<div
												style={{
													display: 'flex',
													alignItems: 'baseline',
												}}
											>
												<img
													style={{
														objectFit: 'contain',
														width: '100%',
														height: 100,
													}}
													src={image}
													alt={image}
												/>
												<div
													style={{
														backgroundColor: 'grey',
														borderRadius: 30,
													}}
												>
													<IconButton
														style={{
															padding: 6,
														}}
														onClick={() => onDelete(index)}
													>
														<DeleteIcon htmlColor='#fff' />
													</IconButton>
												</div>
											</div>
										)}
									</div>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default ImageGridList;
